///<reference path="./smart-mover.models.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import MeevoEventEmitter = Meevo.Components.Common.MeevoEventEmitter;

    export abstract class FilterBase extends MeevoEventEmitter implements ISmartMoverCollectionFilter {
        public abstract readonly templateName: FilterTemplateNames;
        public readonly values: Dictionary<any>;
        public readonly dataTemplate: IDataTemplate;

        public labels: Dictionary<any>;

        get fullTemplatePath(): string {
            return `app/components/controls/smart-mover/filter-templates/${this.templateName}.html`;
        }

        constructor(options: IDataTemplateFilterOptions = {}, dataTemplate: IDataTemplate = null) {
            super();

            this.labels = options.labels;
            this.values = {};
            this.dataTemplate = dataTemplate;
        }

        /**
         * Implement collection update functionality in this method.
         */
        onFilterChange() {
            this.emit('change', this.values);
        }
    }

}
